<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chaptitle"><a id="con"></a>CONTENTS</h1>
<p class="toc"><a href="#/07_chapter01#c1">1 • Premise</a></p>
<p class="toc"><span href="#/08_chapter02#c2" title="Link target outside of Sample">2 • Heart-Centered Activism</span></p>
<p class="toc"><span href="#/09_chapter03#c3" title="Link target outside of Sample">3 • Moving Toward the Millionth Circle</span></p>
<p class="toc"><span href="#/10_chapter04#c4" title="Link target outside of Sample">4 • Stone Cutters</span></p>
<p class="toc"><span href="#/11_chapter05#c5" title="Link target outside of Sample">5 • Sovereignty</span></p>
<p class="toc"><span href="#/12_chapter06#c6" title="Link target outside of Sample">6 • Circle or/and Hierarchy</span></p>
<p class="toc"><span href="#/13_chapter07#c7" title="Link target outside of Sample">7 • Path with Heart</span></p>
<p class="toc"><span href="#/14_chapter08#c8" title="Link target outside of Sample">8 • The Dalai Lama and the Millionth Circle</span></p>
<p class="toc"><span href="#/15_appreciation#apprec" title="Link target outside of Sample">Appreciation</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_contents.vue?c5edc096